import _request from '@/utils/request';
import { _getQuerystr } from '@/utils/commonUtils';

// /team/activityInstance/{teamActivityInstanceId}/join
// [员工]加入团建活动
export async function joinTeamActivity(teamActivityInstanceId) {
  const url = `/team/activityInstance/${teamActivityInstanceId}/join`;
  return await _request({
    method: 'POST',
    url,
  })
}

// GET/team/members/activityInstance/{teamActivityInstanceId}
// [团建成员]根据teamActivityInstanceId查询团建活动实例
export async function getTeamActivityInstance(teamActivityInstanceId) {
  const url = `/team/members/activityInstance/${teamActivityInstanceId}`;
  return await _request({
    method: 'GET',
    url,
  })
}

// GET /team/members/activityInstances
// [团建成员]根据查询参加过的团建活动实例列表 
export async function getTeamActivityInstances() {
  const url = `/team/members/activityInstances`;
  return await _request({
    method: 'GET',
    url,
  })
}

// /team/members/ai/chat
// [团建成员]向AI助手交互
// {
//   "messages": [
//     "string"
//   ],
//   "teamActivityInstanceId": "string",
//   "teamActivityMembersId": "string"
// }
export async function chatWithAI(params) {
  const url = `/team/members/ai/chat`;
  return await _request({
    method: 'POST',
    url,
    data: params,
  })
}

export async function chatWithoutAI(params) {
  const url = `/team/members/chat`;
  return await _request({
    method: 'POST',
    url,
    data: params,
  })
}

// POST /team/members/{teamActivityInstanceId}/startListen
// [团建成员]开始语音监听
export async function startListen(teamActivityInstanceId) {
  const url = `/team/members/${teamActivityInstanceId}/startListen`;
  return await _request({
    method: 'POST',
    url,
  })
}

// POST /team/members/{teamActivityInstanceId}/stopListen
// [团建成员]停止语音监听
export async function stopListen(teamActivityInstanceId) {
  const url = `/team/members/${teamActivityInstanceId}/stopListen`;
  return await _request({
    method: 'POST',
    url,
  })
}

// GET /currentSpeakStatus?teamActivityInstanceId=
// [团建成员]查询当前说话状态
export async function getCurrentSpeakStatus(teamActivityInstanceId) {
  const url = `/team/currentSpeakStatus?teamActivityInstanceId=${teamActivityInstanceId}`;
  return await _request({
    method: 'GET',
    url,
  })
}

// /team/members/ai/chat/lock
// [团建成员]获得和AI助手交互的独占权利
// {
//   "teamActivityInstanceId": "string"
// }
export async function lockAI(params) {
  const url = `/team/members/ai/chat/lock`;
  return await _request({
    method: 'POST',
    url,
    data: params,
  })
}

// /team/members/ai/chat/release
// [团建成员]释放和AI助手交互的独占权利
// {
//   "teamActivityInstanceId": "string"
// }
export async function releaseAI(params) {
  const url = `/team/members/ai/chat/release`;
  return await _request({
    method: 'POST',
    url,
    data: params,
  })
}
// /members/ai/greeting
export async function greetingAI(teamActivityInstanceId) {
  const url = `/team/members/ai/greeting?teamActivityInstanceId=${teamActivityInstanceId}`;
  return await _request({
    method: 'POST',
    url,
  })
}


// /team/members/diyAiChild/create
// [团建成员]捏内在娃娃
// teamActivityInstanceId: "string",
// param
// {
//   "avatarDescription": {},
//   "avatarVersion": false,
//   "childGender": "string",
//   "childNickName": "string",
//   "childPhotoUrlList": [
//     "string"
//   ],
//   "producerAge": 0,
//   "producerGender": "string",
//   "producerPhotoUrlList": [
//     "string"
//   ],
//   "selectedFeatures": [
//     "string"
//   ]
// }

export async function createDiyAiChild(params, data) {
  const url = `/team/members/diyAiChild/create${_getQuerystr(params)}`;
  return await _request({
    method: 'POST',
    url,
    data,
  })
}

// POST
// /team/members/diyAiChild/createInnerChildReport
// [团建成员]创建内在娃娃报告
export async function teamMembersCreateInnerChildReport(params, data) {
  const url = `/team/members/diyAiChild/createInnerChildReport${_getQuerystr(params)}`;
  return await _request({
    method: 'POST',
    url,
    data
  })
}
// GET
// /team/members/diyAiChild/getInnerChild
// [团建成员]根据teamActivityInstanceId查询自己的内在娃娃
export async function getInnerChild(teamActivityInstanceId) {
  const url = `/team/members/diyAiChild/getInnerChild?teamActivityInstanceId=${teamActivityInstanceId}`;
  return await _request({
    method: 'GET',
    url,
  })
}
// GET
// /team/members/diyAiChild/getChildResult
// [团建成员]查询内在娃娃测评结果
export async function getChildResult(aiChildId) {
  const url = `/team/members/diyAiChild/getChildResult?aiChildId=${aiChildId}`;
  return await _request({ method: 'GET', url })
}

// GET
// /team/members/diyAiChild/getInnerChildReport
// [团建成员]根据teamActivityInstanceId查询自己的内在娃娃报告
export async function getInnerChildReport(teamActivityInstanceId) {
  const url = `/team/members/diyAiChild/getInnerChildReport?teamActivityInstanceId=${teamActivityInstanceId}`;
  return await _request({
    method: 'GET',
    url,
  })
}
// POST
// /team/members/teamActivityInstance/{teamActivityInstanceId}/wishMessage
// [团建成员]发送活动寄语
export async function sendWishMessage(teamActivityInstanceId, params) {
  const url = `/team/members/teamActivityInstance/${teamActivityInstanceId}/wishMessage`;
  return await _request({
    method: 'POST',
    url,
    data: params,
  })
}
// /team/members/replyForm
// {
//   "formAnswers": {},
//   "metrics": [
//     "string"
//   ],
//   "rawAnswers": {},
//   "shufuFormId": "string",
//   "teamActivityInstanceId": "string"
// }
export async function teamMemberReplyForm(params) {
  const url = `/team/members/replyForm`;
  return await _request({
    method: 'POST',
    url,
    data: params,
  })
}

// /team/members/formAnswer
// 查询提交答案
export async function teamMemberGetFormAnswer(params) {
  const url = `/team/members/formAnswer${_getQuerystr(params)}`;
  return await _request({
    method: 'GET',
    url,
  })
}
// 新增GET ： /members/currentMember?teamActivityInstanceId=${teamActivityInstanceId} 查询当前登录staff 是否加入本次活动，如果没有加入则返回null
export async function getCurrentMember(teamActivityInstanceId) {
  const url = `/team/members/currentMember?teamActivityInstanceId=${teamActivityInstanceId}`;
  return await _request({
    method: 'GET',
    url,
  })
}

// /team/members/diyAiChild/getLastTeamReport
// [团建成员] 查询最近一条团体报告
export async function getLastTeamReport(teamActivityInstanceId) {
  const url = `/team/members/diyAiChild/getLastTeamReport?teamActivityInstanceId=${teamActivityInstanceId}`;
  return await _request({
    method: 'GET',
    url,
  })
}

// /team/members/diyAiChild/images
// [团建成员]查询团队所有内在娃娃
export async function getTeamDiyAiChild(teamActivityInstanceId) {
  const url = `/team/members/diyAiChild/images?teamActivityInstanceId=${teamActivityInstanceId}`;
  return await _request({
    method: 'GET',
    url,
  })
}

// GET /team/members/voteActivity
// [团建成员]获取投票活动
export async function getVoteActivity(params) {
  const url = `/team/members/voteActivity${_getQuerystr(params)}`;
  return await _request({
    method: 'GET',
    url,
  })
}

// POST /team/members/voteCast
// [团建成员]提交投票
export async function castVote(params) {
  const url = `/team/members/voteCast`;
  return await _request({
    method: 'POST',
    url,
    data: params,
  })
}

// GET /team/members/voteRecodes/{voteActivityId}
// [团建成员]获取用户投票记录
export async function getVoteRecords(voteActivityId) {
  const url = `/team/members/voteRecodes/${voteActivityId}`;
  return await _request({
    method: 'GET',
    url,
  })
}

// 获取团队吉祥物/members/mascots
export async function getTeamMascots(teamActivityInstanceId) {
  const url = `/team/members/mascots?teamActivityInstanceId=${teamActivityInstanceId}`;
  return await _request({
    method: 'GET',
    url,
  })
}

// 获取投票结果`/team/vote/results/${voteActivityId}`
export async function getVoteResults(voteActivityId) {
  const url = `/team/vote/results/${voteActivityId}`;
  return await _request({
    method: 'GET',
    url,
  })
}

// GET /team/diyAiChild/currentGuessDollStatus?teamActivityInstanceId=...
// Returns: { aiChildId, answer, currentStatus, pickUpDollStaffId, revealedDollIds }
export async function getCurrentGuessDollStatus(teamActivityInstanceId) {
  const url = `/team/diyAiChild/currentGuessDollStatus?teamActivityInstanceId=${teamActivityInstanceId}`;
  return await _request({
    method: 'GET',
    url,
  })
}

// POST /team/members/diyAiChild/selectDollToGuess
// Query: { teamActivityInstanceId, aiChildId }
export async function selectDollToGuess(teamActivityInstanceId, aiChildId) {
  const url = `/team/members/diyAiChild/selectDollToGuess${_getQuerystr({
    teamActivityInstanceId,
    aiChildId,
  })}`;
  return await _request({
    method: 'POST',
    url,
  })
}

// POST /team/members/diyAiChild/clue
// [团建成员]提交娃娃线索
export async function submitDiyAiChildClue(params) {
  const url = `/team/members/diyAiChild/clue`;
  return await _request({ method: 'POST', url, data: params });
}

// GET /team/members/diyAiChild/getDollClue
// [团建成员]获取娃娃线索问题
export async function getDollClue(aiChildId) {
  const url = `/team/members/diyAiChild/getDollClue?aiChildId=${aiChildId}`;
  return await _request({ method: 'GET', url });
}

// POST /team/members/diyAiChild/answer/clue
// [团建成员]提交线索问题回答
export async function answerDollClue(params) {
  const url = `/team/members/diyAiChild/answer/clue`;
  return await _request({ method: 'POST', url, data: params });
}
